// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunks/bonusprogram-" + chunkId + "." + {"1":"7481b23b","2":"6d4d8426","3":"83a9b9bd","4":"aa002ee4","5":"2c30bcfa","6":"3d9c8aa2","7":"10220df8"}[chunkId] + ".min.js";
};